<div class="col-12 pl-0">  
  <div class="row">
    <div class="col-6">
      <h5>User Access</h5>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label>The following registered users will have access to the credit purchase record in their Personal Landing Page</label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 form-inline">
          <label class="control-label">User Access Table</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <ag-grid-angular [style.width.%]="90" [style.height]="height"
            class="ag-theme-alpine"
            [rowData]="userAccessList"
            [columnDefs]="userAccessColumnDefs"
            [pagination]="true"
            [paginationPageSize]="10"
            [defaultColDef]="defaultColDef"
            (gridReady)="onUserAccessGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
    
</div>
